import React, { useContext, useEffect, useState, createContext } from 'react';

const KEY = 'ashr_record_override';
const EVENT = 'ashr-record-override';

const sessionUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
};

export const isRecordKeeper = (user = sessionUser()) => !!(user && user.record_keeper && !user.preview);

export const isSalaryKeeper = (user = sessionUser()) => !!(user && user.salary_keeper && !user.preview);

export const recordOverrideOn = () => isRecordKeeper() && sessionStorage.getItem(KEY) === '1';

export const setRecordOverride = (on) => {
  if (on && isRecordKeeper()) sessionStorage.setItem(KEY, '1');
  else sessionStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVENT));
};

const Ctx = createContext(false);

export const RecordOverrideProvider = ({ children }) => {
  const [on, setOn] = useState(recordOverrideOn());
  useEffect(() => {
    const sync = () => setOn(recordOverrideOn());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  return <Ctx.Provider value={on}>{children}</Ctx.Provider>;
};

export const useRecordOverride = () => useContext(Ctx);
